import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'Serial',
        caption: 'Serial number',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: true,
        allowEditing: false,
        allowSorting: true,
    },
    // We may enable it if we need an empty column as one column takes all the space.
    // {
    //     dataField: '__empty__',
    //     caption: '',
    //     allowFiltering: false,
    //     allowSorting: false,
    //     width: 50,
    //     cellRender: () => null,
    // }
];
